"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DsvSpecialRows = exports.DsvLabels = void 0;
exports.DsvLabels = [
    'asin',
    'street_date',
    'averageCustomerReviews',
    'amazonSalesRankSummary',
    'priceLegalInfo',
    'binding',
    'dsvTermsOfUse',
    'itemModelNumber',
    'item_size_weight',
    'itemWeight',
    'rating',
    'publisher',
    'product_site_launch_date'
];
exports.DsvSpecialRows = [
    'averageCustomerReviews',
    'priceLegalInfo',
    'dsvTermsOfUse',
    'amazonSalesRankSummary'
];
